import { createApp } from 'vue'
import { nextTick } from '@vue/runtime-core'
import ant from 'ant-design-vue'
import { message } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import App from './App.vue'
import dayjs from 'dayjs'
import { router } from './plugins/router'
import i18n from './plugins/i18n'
import { api } from '@/util/api'
import * as date from '@/util/date'
import * as excel from '@/util/excel'
import * as list from '@/util/list'
import * as number from '@/util/number'
import * as data from '@/util/data'
import { notice } from '@/util/notice'
import { authsHandler } from '@/util/btnAuths'
import { upload } from '@/util/upload'
import store from '@/store'
// editor
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
// v-viewer
import VueViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// custom select
import CustomSelect from '@/components/common/CustomSelect.vue'

const isPhone = navigator.userAgent.includes('Mobile')

const app = createApp(App)

nextTick(() => {
  app.config.globalProperties.$isPhone = isPhone
})

// 註冊全域變數
app.provide('$message', message)
app.provide('$api', api)
app.provide('$t', i18n.global.t)
app.provide('$dayjs', dayjs)
app.provide('$date', date)
app.provide('$excel', excel)
app.provide('$list', list)
app.provide('$number', number)
app.provide('$data', data)
app.provide('$notice', notice)
app.provide('$authsHandler', authsHandler)
app.provide('$upload', upload)

app.component('QuillEditor', QuillEditor)
app.component('CustomSelect', CustomSelect)

app
  .use(router)
  .use(i18n)
  .use(ant)
  .use(store)
  .use(VueViewer, {
    defaultOptions: {
      // v-viewer 圖片預覽器的z-index預設為2015; view-design modal的z-index為 1165。
      // 但view-design modal每次開啟z-index都會累加，所以有可能一直點擊，z-index最後會大於v-viewer的情況，所以為了避免此問題，直接將v-viewer的z-index設為 30000
      zIndex: 30000,
    },
  })
  .mount('#app')
